<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px" [ngClass]="{ preview: isPreview }">
  <div [fxFlex]="data?.length! > 0 && !isPreview ? '50' : '100'" fxFlex.lt-lg="100">
    <nz-layout class="table-margin">
      <nz-header class="table-header">
        <!--  -->
        @if (isEOC() || isInpatientView() || isPreview || (data?.length! > 0 || isLoading)) {
          <div
            class="table-header-row margin-lr">
            <div class="table-header-cell">
              {{ "Hysteroscopy Files" | translate }}
            </div>
            <!--  -->
            <div class="table-header-cell margin-lrr" *hasAddPermissions="['a-hy']">
              @if (
                (isEOC() || isInpatientView()) &&
                !isPreview
                ) {
                <button nz-button nzShape="round" (click)="openModal()">
                  <div fxLayout="row">
                    <div fxLayout="col">
                      <mat-icon class="add-icon">add_circle_outline</mat-icon>
                    </div>
                    <div fxLayout="col" class="add-title">
                      {{ "Add" | translate }} {{ "Hysteroscopy File" | translate }}
                    </div>
                  </div>
                </button>
              }
            </div>
          </div>
        }

        @if (
          !(isEOC() || isInpatientView()) &&
          !isPreview &&
          !(data?.length! > 0)
          ) {
          <div fxLayout="row" class="table-header-row">
            @if (!isLoading) {
              <div fxLayout="col" class="title">
                {{ "Hysteroscopy Files" | translate }} -
                {{ "No data available" | translate }}
              </div>
            }
          </div>
        }
      </nz-header>
      @if (data?.length! > 0 || isLoading) {
        <nz-content>
          <nz-table #nzTable nzTableLayout="fixed" nzShowTitle="false" nzSize="middle"
            nzNoResult="No Hysteroscopy Files found" [nzLoading]="isLoading" [nzData]="data || []"
            [nzShowPagination]="pagination" [nzShowSizeChanger]="pagination" nzPaginationType="default"
            [nzFrontPagination]="pagination" [nzPageIndex]="currentPageIndex"
            (nzPageIndexChange)="handlePageIndexChange($event)" (nzPageSizeChange)="handlePageSizeChange($event)"
            [nzPageSizeOptions]="[10, 15, 20]" [nzPageSize]="pageSize">
            <thead>
              <tr>
                @for (
                  col of ['Anatomical Position', 'Date', 'Description']
                  ; track
                  col) {
                  <th>
                    {{ col | translate }}
                    <app-tooltip [fieldName]="col" area="Hysteroscopy" />
                  </th>
                }
                @if (hasUnsubmitted() && !isPreview) {
                  <th nzWidth="70px">
                    {{ "Actions" | translate }}
                    <app-tooltip fieldName="Actions" area="Hysteroscopy" />
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of getData(); track item) {
                <tr
                  [ngClass]="{'draft-entry': !item?.['isSubmitted'] && (isEOC()||isInpatientView()), 'selected-preview': fileItem?.id === item.id}"
                  (click)="requestFile(item)">
                  @for (
                    field of ['anatomicalPosition', 'date', 'description']
                    ; track
                    field) {
                    <td>{{ getValue(field, item[field]?.toString()) }}</td>
                  }
                  @if (
                    (isEOC() || isInpatientView()) &&
                    !item['isSubmitted'] &&
                    !isPreview
                    ) {
                    <td>
                      <i nz-icon nzType="icons:delete" nzTheme="outline" class="delete-btn"
                      (click)="deleteFun(item?.id!); $event.stopPropagation()"></i>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </nz-table>
        </nz-content>
      }
    </nz-layout>
  </div>
  @if (data?.length! > 0 && !isPreview) {
    <div [fxFlex]="50" fxFlex.lt-lg="100">
      <div class="document-view">
        <div class="preview-title">
          {{ "Preview" | translate }}
          {{
          fileItem?.anatomicalPosition
          ? " - " + fileItem?.anatomicalPosition
          : ""
          }}
          @if (fileObj && !isPreviewLoading) {
            <span nz-icon nzType="icons:download" nzTheme="outline"
            class="download-btn" (click)="downloadFile(fileItem!)"></span>
          }
        </div>
        <div class="preview-content" fxLayoutAlign="center center">
          @if (!fileObj && !isPreviewLoading) {
            <div>
              <i nz-icon nzType="icons:folder-view" nzTheme="outline" class="folder-view-icon"></i>
              <div>{{ "Select a Hysteroscopy File to preview!" | translate }}</div>
            </div>
          }
          @if (isPreviewLoading) {
            <div>
              <nz-spin nzSimple></nz-spin>
            </div>
          }
          @if (fileType === 'image' && fileObj) {
            <img [src]="fileObj" alt="Image preview"
              style="max-width: 100%; height: auto" />
          }
          @if (fileType === 'video' && fileObj) {
            <video [src]="fileObj" controls class="video-viewer"></video>
          }
        </div>
      </div>
    </div>
  }
</div>

<!-- <nz-modal #modalRef nzSize [(nzVisible)]="isVisible"
[nzTitle]="('Preview' | translate) + (fileItem?.examTitle ? ' - ' + fileItem?.examTitle : '')"
(nzOnCancel)="handleCancel()" nzCancelText="Cancel" nzOkText="Save" nzOkType="primary" [nzFooter]="null"
class="custom-modal-class">

<ng-container *nzModalContent>
    <video *ngIf="
      fileType === 'video' && fileObj && fileItem && !isPreviewLoading
    " controls class="modal-video">
    <source [src]="fileObj" type="video/mp4" *ngIf="fileObj?.includes('.mp4')" />
    <source [src]="fileObj" type="video/x-msvideo" *ngIf="fileObj?.includes('.avi')" />
    <source [src]="fileObj" type="video/quicktime" *ngIf="fileObj?.includes('.mov')" />
    Your browser does not support the video tag.
  </video>
</ng-container>
</nz-modal> -->

<div *ngComponentOutlet="addComp"></div>